// src/utils/feedbackTracker.js
import { supabase } from '../supabaseClient'

const sessionId = crypto.randomUUID()
export function getSessionId() { return sessionId }
export function generatePlaybackId() { return crypto.randomUUID() }

async function getAccessToken() {
  try {
    const { data: { session } } = await supabase.auth.getSession()
    return session?.access_token || null
  } catch {
    return null
  }
}

/**
 * 軽量トラッキング：sendBeacon最優先（本文にaccess_tokenを含める）
 * fire-and-forget（awaitしない）でUIを止めません。
 */
export async function track(eventType, payload = {}) {
  try {
    const token = await getAccessToken()
    const eventData = {
      event_type: eventType,
      session_id: sessionId,
      ts: Date.now(),
      ua: navigator.userAgent || '',
      device: /Mobi/.test(navigator.userAgent) ? 'mobile' : 'desktop',
      ...payload,
      ...(token ? { access_token: token } : {})
    }

    const body = JSON.stringify(eventData)
    const blob = new Blob([body], { type: 'text/plain' }) // ← sendBeacon向け
    const base = import.meta.env.VITE_API_BASE_URL || 'https://api.otoeigo.com'
    const url = `${base}/api/feedback-events`

    if (navigator.sendBeacon) {
      const ok = navigator.sendBeacon(url, blob)
      if (ok) {
        console.debug('track: sendBeacon ok', eventData.event_type)
        return
      } else {
        console.warn('track: sendBeacon returned false, skip fallback')
      }
    }

    // フォールバック（必要最小限）
    try {
      await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body,
        keepalive: true
      })
      console.debug('track: fetch fallback ok')
    } catch (e) {
      console.warn('track: fetch fallback failed', e)
    }

  } catch (error) {
    console.error('track: unexpected error', error)
  }
}
